import React from "react";
import { Button } from "src/components/ui/button";
import { Ban } from "lucide-react";

import { useAuth } from "src/contexts/AuthContext";

// Full-screen block shown when the org's subscription has lapsed or a
// superadmin suspended it. Rendered by ProtectedRoute instead of the CRM —
// the backend also 403s every API call, this is just the friendly face of it.
export default function OrganizationDeactivatedPage() {
  const { organization, logout } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-50">
          <Ban className="h-7 w-7 text-red-500" />
        </div>
        <h1 className="mt-4 text-lg font-semibold text-slate-900">
          {organization?.name ? `${organization.name} is deactivated` : "Organization deactivated"}
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-slate-500">
          Your organization is deactivated, please contact admin to continue operations.
        </p>
        <Button
          variant="outline"
          onClick={logout}
          className="mt-6 inline-flex items-center justify-center rounded-lg border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50"
        >
          Sign out
        </Button>
      </div>
    </div>
  );
}
